<template>
  <UiTableWithPagination
    :data="items"
    :loading="loading"
    :page="page"
    :per-page="perPage"
    :total="total"
    @update:page="$emit('update:page', $event)"
    @update:per-page="$emit('update:perPage', $event)">
    <ElTableColumn prop="title" :label="$t('Supplier.NameSupplier')" />
    <ElTableColumn prop="phone" :label="$t('Supplier.ContactPerson')" />
    <ElTableColumn prop="contact_person" :label="$t('Supplier.PhoneNumber')" />
    <ElTableColumn prop="description" :label="$t('Nomenclature.Notes')" />
    <ElTableColumn :label="$t('Nomenclature.Actions')" width="150px">
      <template #default="{ row }">
        <ElButton size="small" type="primary" plain @click.stop="$emit('modal:open', row)"
          >{{ $t('Nomenclature.Edit') }}
        </ElButton>
      </template>
    </ElTableColumn>
  </UiTableWithPagination>
</template>
<script lang="ts">
import { PropType } from 'vue';

import { SupplierDto } from '@/types/api';
import UiTableWithPagination from '@/components/ui/UiTableWithPagination/index.vue';

export default {
  name: 'SuppliersTable',
  components: {
    UiTableWithPagination,
  },
  emits: ['update:page', 'update:perPage', 'modal:open'],
  props: {
    loading: { type: Boolean, required: true },
    items: { type: Array as PropType<SupplierDto[]>, required: true },
    page: { type: Number, required: true },
    perPage: { type: Number, required: true },
    total: { type: Number, required: true },
  },
};
</script>

<style lang="scss" scoped></style>
<i18n src="@/locales/base.locales.json" />
<i18n src="@/locales/warehouse.locales.json" />
